import React from "react";
import { useTranslation } from "react-i18next";
import { Investment } from "@bn/api/apiv1";
import { Banner } from "@components";
import { useIsinValidation } from "@hooks";

interface Props {
  investment?: Investment;
  onEditIsin: () => void;
}

export const InvestmentIsinBanner = ({ investment, onEditIsin }: Props) => {
  const { t } = useTranslation();
  const { isIsinValid } = useIsinValidation(investment ?? {});

  if (!investment || isIsinValid) {
    return null;
  }

  return (
    <Banner
      displayDefaultIcon
      type="error"
      title={t("investment.isinMissing.title")}
      text={t("investment.isinMissing.subtitle")}
      primaryButton={{
        label: t("investmentEditPage.tabs.advanced"),
        onClick: onEditIsin,
      }}
      mb={4}
    />
  );
};
